/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import cloneDeep from 'lodash.clonedeep';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Tag, TreeSelect, message } from 'antd';
import { DownloadOutlined, FilePdfOutlined } from '@ant-design/icons';
import axios from 'axios';
import StyledTable from '../../commons/styles/table';
import { IPAddress, REPORTS } from '../../commons/api';
import SelectionComponent from './SelectionComponent';
import SelectComponent from './SelectComponent';
import {
  getDataSourceFromBackend,
  getReportNametoDownload,
  getPdfNametoDownload,
  getReportNametoDownloadMultiVaraint
} from './ReportCalls';
import { getTranslatedDatasource } from './ReportAdapter';
import localStorage from '../../utils/localStorage';

import './style.css';
import TreeSelectComponent from './TreeSelect';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useCallback } from 'react';

const { SHOW_PARENT } = TreeSelect;

dayjs.extend(timezone);
dayjs.extend(utc);

export const ChildTablesGroup = styled.div`
  width: 100%;
  text-align: center;
  line-height: 75px;
`;

const ReportTable = (props) => {
  const [columns, setColumns] = useState(props.columns || []);
  const [currentDatasource, setCurrentDatasource] = useState(props.currentDatasource || []);
  const [reportName, setReportName] = useState('');
  const [childDatasource, setChildDatasource] = useState([]);
  const [weekSummaryDatasource, setWeekSummaryDatasource] = useState([]);
  const [tableConfiguration, setTableConfiguration] = useState({
    bordered: props.tableConfiguration?.bordered ?? true,
    horizontalScroll: props.tableConfiguration?.horizontalScroll ?? false,
    pagination: props.tableConfiguration?.pagination ?? false,
    tableSize: props.tableConfiguration?.tableSize ?? 'default',
    noResultMessage: props.tableConfiguration?.noResultMessage ?? 'No Records',
    isCursorPointer: props.tableConfiguration?.isCursorPointer ?? false,
    title: props.tableConfiguration?.title ?? "",
    pageSize: props.tableConfiguration?.pageSize ?? '10',
    downloadXLXS: props.tableConfiguration?.downloadXLXS ?? false,
    downloadExcelPayload: props.tableConfiguration?.downloadExcelPayload ?? {},
    downloadPdf: props.tableConfiguration?.downloadPdf ?? false,
    downloadPdfPayload: props.tableConfiguration?.downloadPdfPayload ?? {},
    columnFilter: props.tableConfiguration?.columnFilter ?? false,
    headerSelection: props.tableConfiguration?.headerSelection ?? [],
    style: {
      textAlign: props.tableConfiguration?.style?.textAlign ?? 'center',
      evenRowColor: props.tableConfiguration?.style?.evenRowColor ?? 'rgb(251, 250, 250)',
      oldRowColor: props.tableConfiguration?.style?.oldRowColor ?? '#fff',
    },
    showStatus: props.tableConfiguration?.showStatus ?? false,
    prepareDynamicColumns: props.tableConfiguration?.prepareDynamicColumns ?? {},
  });

  const [selectionObject, setSelectionObject] = useState({
    // Month: moment().format('MMMM'),
    // Year: moment().year()
  });
  const [selectedDevice, setSelectedDevice] = useState('FRM_1_TRBN_1');
  const [treeData, setTreeData] = useState([]);
  const [value, setValue] = useState([]);
  const [summaryValue, setSummaryValue] = useState([]);
  const [summaryTable, setSummaryTable] = useState([]);
  const [TagsList, setTagsList] = useState([]);
  const [pdfName, setPdfName] = useState('');
  const [api, setApi] = useState(props.api || []);
  const [deviceTreeData, setDeviceTreeData] = useState([]);
  const [initalRender, setInitalRender] = useState({
    initalRender: true,
    optionList: []
  });
  const [filteredInfo, setFilteredInfo] = useState(null);
  const timeTicketRef = useRef(null);


  const _getDevicesList = useCallback(async () => {
    const deviceSelectionData = props.deviceSelection;
    const payload = deviceSelectionData ? deviceSelectionData.api : {};
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let url = payload && payload.method === 'GET'
      ? `${payload.uri}?SiteId=${siteId}&${payload.payload}`
      : `${payload.uri}?SiteId=${siteId}`;
    let payloadData = payload && payload.payload ? payload.payload : '';
    const ObjectHeader = {
      method: payload.method,
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payloadData || {}
    };

    try {
      const response = await axios(ObjectHeader);
      return response.data;
    } catch {
      return [];
    }
  }, [props.deviceSelection]);

  const _getDataSource = useCallback(async () => {
    let summaryTableClone = [];
    let api = cloneDeep({
      ...props.api,
      payload: {
        ...(props.api && props.api.payload ? props.api.payload : {}),
        AssetCode: props.AssetCode
      }
    });

    let columnsClone = cloneDeep(props.columns);
    let multiVaraintColumns = cloneDeep(props.nestedChildColumns || []);
    columnsClone = await getTranslatedDatasource(columnsClone, props.translationCache);

    let { selectionWidget, childTable, weekSummaryTable, tableConfiguration } = props;
    summaryTableClone = childTable?.[0]?.columns || [];

    if (childTable?.[0]?.columns) {
      summaryTableClone = await getTranslatedDatasource(childTable && childTable[0] ? childTable[0].columns : [], props.translationCache);
    }

    // Column validation logic
    if (api?.payload?.isEquipment === 'no') {
      columnsClone = await columnValidation(columnsClone, 'no');
    } else {
      columnsClone = await columnValidation(columnsClone, 'yes');
    }

    if (props.tableConfiguration?.generateCol) {
      columnsClone = Array.isArray(columnsClone)
        ? columnsClone.map((column) => {
          let conditionType = column.conditionType;
          if (column.condition === true && conditionType) {
            return {
              ...column,
              render: (text, record) => {
                if (record?.durationType && conditionType[record.durationType]) {
                  const { format, conditionFormat, combineColumnList } = conditionType[record.durationType];

                  if (
                    conditionFormat === 'combineTwoColumns' &&
                    Array.isArray(combineColumnList) &&
                    combineColumnList.length === 2
                  ) {
                    const startDate = record[combineColumnList[0]];
                    const endDate = record[combineColumnList[1]];
                    const start = dayjs.utc(startDate).tz(props.currentTimeZone).format(format);
                    const end = dayjs.utc(endDate).tz(props.currentTimeZone).format(format);
                    return <div>{`${start} - ${end}`}</div>;
                  }

                  return format
                    ? <div>{dayjs.utc(text).tz(props.currentTimeZone).format(format)}</div>
                    : <div>{text}</div>;
                }
                return <div>{text}</div>;
              }
            };
          }
          return column;
        })
        : columnsClone;
    }

    let treeDataNew = await _generateTreeData(columnsClone);
    setColumns(columnsClone);
    setTreeData(treeDataNew.treeData);
    setValue(treeDataNew.value);
    setSummaryValue(treeDataNew.summaryValue);

    // Selection object logic
    let month = moment().month();
    let year = moment().year();
    let selectionObjectClone = {
      timeZone: props.currentTimeZone
    };

    if (selectionWidget?.payload) {
      Object.keys(selectionWidget.payload).forEach((payloadParams, key) => {
        let payloadItem = selectionWidget.payload[payloadParams];

        if (key === 0) {
          selectionObjectClone[payloadParams] = getStartDate(selectionWidget.widget, payloadItem.format, year, month);
        } else if (key === 1) {
          selectionObjectClone[payloadParams] = getEndDate(selectionWidget.widget, payloadItem.format, year, month);
        }

        if (payloadParams === 'month') selectionObjectClone[payloadParams] = moment().format('MMMM');
        if (payloadParams === 'year') selectionObjectClone[payloadParams] = year;
        if (payloadParams === 'Date') selectionObjectClone[payloadParams] = moment().subtract(1, 'day').format('YYYY-MM-DD');

        if (payloadParams === 'startDate') {
          if (selectionWidget.widget === 'month-picker') {
            selectionObjectClone[payloadParams] = moment()
              .subtract(1, 'month')
              .endOf('month')
              .utc()
              .format("YYYY-MM-DD HH:30:00");
          } else {
            selectionObjectClone[payloadParams] = moment()
              .startOf('day')
              .utc()
              .format("YYYY-MM-DD HH:mm:ss");
          }
        }

        if (payloadParams === 'endDate') {
          if (selectionWidget.widget === 'month-picker' && selectionWidget.payload.isConsiderWholeMonth === true) {
            selectionObjectClone[payloadParams] = moment()
              .endOf('month')
              .utc()
              .format("YYYY-MM-DD HH:mm:ss");
          } else if (selectionWidget.widget === 'date-picker' && selectionWidget.payload.isConsiderWholeDay === false) {
            selectionObjectClone[payloadParams] = moment()
              .utc()
              .format("YYYY-MM-DD HH:mm:ss");
          } else if (selectionWidget.widget === 'dayMonthYear-picker' && selectionWidget.payload.isConsiderWholeDayMonthYear === false) {
            selectionObjectClone[payloadParams] = moment()
              .utc()
              .format("YYYY-MM-DD HH:mm:ss");

          }

          else {
            selectionObjectClone[payloadParams] = moment()
              .endOf('day')
              .utc()
              .format("YYYY-MM-DD HH:mm:ss");
          }
        }
      });
    }
    if (selectionWidget && selectionWidget.widget === 'dayMonthYear-picker') {
      selectionObjectClone['selectionType'] = "DAY";
    }

    let TagsListClone = Array.isArray(columnsClone)
      ? columnsClone.map((col) => col.key)
      : [];

    if (api) {
      if (tableConfiguration?.columnFilter === 'true') {
        api.payload = {
          ...api.payload,
          ...selectionObjectClone,
          ...selectionObject,
          DeviceCode: selectedDevice,
          language: props.CurrentLanguage,
          TagsList: TagsListClone.filter(
            (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
          )
        };
      } else {
        if (props.reportName !== "Power Generation Report") {
          api.payload = {
            ...api.payload,
            ...selectionObjectClone,
            language: props.CurrentLanguage,
            DeviceCode: selectedDevice,
            date: dayjs().format("YYYY-MM-DD"),
            days: dayjs().daysInMonth(),
            tags: TagsList
          };
        } else {
          return {};
        }
      }
    }

    // Handle child table datasource
    let childDatasourceClone = [];
    if (childTable?.[0]?.api) {
      const childApi = childTable[0].api;
      if (tableConfiguration?.columnFilter === 'true') {
        childApi.payload = {
          ...childApi.payload,
          ...selectionObjectClone,
          ...selectionObject,
          TagsList: TagsListClone.filter(
            (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
          )
        };
      } else {
        childApi.payload = {
          ...childApi.payload,
          ...selectionObjectClone,
          ...selectionObject
        };
      }

      childDatasourceClone = await getDataSourceFromBackend(childApi);
      setChildDatasource(childDatasourceClone);
    }

    // Week summary table
    let weekSummaryDatasourceClone = [];
    if (weekSummaryTable?.api) {
      const weekApi = weekSummaryTable.api;
      if (tableConfiguration?.columnFilter === 'true') {
        weekApi.payload = {
          ...weekApi.payload,
          ...selectionObjectClone,
          ...selectionObject,
          TagsList: TagsListClone.filter(
            (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
          )
        };
      } else {
        weekApi.payload = {
          ...weekApi.payload,
          ...selectionObjectClone,
          ...selectionObject
        };
      }

      weekSummaryDatasourceClone = await getDataSourceFromBackend(weekApi);
      setWeekSummaryDatasource(weekSummaryDatasourceClone);
    }

    let filteredInfoClone = filteredInfo || {};
    let currentDatasourceClone = await getDataSourceFromBackend(api);

    // Prepare dynamic columns if needed
    if (
      tableConfiguration?.prepareDynamicColumns?.enable &&
      currentDatasourceClone?.[0]
    ) {
      columnsClone = generateColumnsFromDatasource(currentDatasourceClone[0]);

      const reportNameClone = await getReportNametoDownload(
        columnsClone,
        currentDatasourceClone,
        tableConfiguration.downloadExcelPayload,
        childTable?.[0]?.columns || [],
        childDatasourceClone,
        weekSummaryDatasourceClone,
        {
          SelectedDate:
            moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm') +
            '~' +
            moment.utc(selectionObject.endDate).local().format('YYYY-MM-DD HH:mm')
        },
        tableConfiguration
      );

      let treeDataNewClone = await _generateTreeData(columnsClone);
      setReportName(reportNameClone);
      setColumns(columnsClone);
      setValue(treeDataNewClone.value);
    }

    // Set filters and custom renderers
    if (Array.isArray(currentDatasourceClone)) {
      columnsClone.forEach((col, i) => {
        if (col?.filter) {
          let filterOptions = currentDatasourceClone
            .map((ds) => {
              if (ds[columnsClone[i].key] !== null) {
                return {
                  text: ds[columnsClone[i].key],
                  value: ds[columnsClone[i].key]
                };
              }
              return {};
            })
            .filter(Boolean);

          columnsClone[i] = {
            ...col,
            filters: _.uniqBy(filterOptions, 'text'),
            filteredValue: filteredInfoClone[columnsClone[i].key] || null,
            onFilter: (value, record) => record[columnsClone[i].key].includes(value),
            ellipsis: true
          };
        }

        if (col.key === 'Action') {
          columnsClone[i] = {
            ...col,
            render: () => (
              <a href="/#" target="_blank" rel="noopener noreferrer">
                action
              </a>
            )
          };
        }
      });
    }

    // Handle Excel download name
    let reportNameClone = '';
    if (tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
      if (
        tableConfiguration.downloadExcelPayload?.summaryType === true &&
        childTable && childTable?.[0]?.columns &&
        tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true'
      ) {
        reportNameClone = await getReportNametoDownload(
          columnsClone,
          currentDatasourceClone,
          tableConfiguration.downloadExcelPayload,
          childTable && childTable[0] ? childTable[0].columns : [],
          childDatasourceClone,
          weekSummaryDatasourceClone,
          {
            SelectedDate:
              moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm') +
              '~' +
              moment.utc(selectionObject.endDate).local().format('YYYY-MM-DD HH:mm')
          },
          tableConfiguration
        );
      } else if (props.nestedChildColumns && tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        reportNameClone = await getReportNametoDownloadMultiVaraint(
          columnsClone,
          currentDatasourceClone,
          multiVaraintColumns,
          tableConfiguration.downloadExcelPayload
        );
      } else if (tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        reportNameClone = await getReportNametoDownload(
          columnsClone,
          currentDatasourceClone,
          tableConfiguration.downloadExcelPayload,
          childTable?.[0]?.columns || [],
          childDatasourceClone,
          weekSummaryDatasourceClone,
          {
            SelectedDate:
              moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm') +
              '~' +
              moment.utc(selectionObject.endDate).local().format('YYYY-MM-DD HH:mm')
          },
          tableConfiguration
        );
      }

      setCurrentDatasource(currentDatasourceClone);
      setSummaryTable(summaryTableClone);
      setReportName(reportNameClone?.file || '');
      setApi(api);
      setSelectionObject(selectionObject);
    } else {
      setCurrentDatasource(currentDatasourceClone);
      setSummaryTable(summaryTableClone);
      setTagsList(TagsListClone);
      setApi(api);
      setSelectionObject(selectionObject);
    }

    // Handle PDF name
    let pdfNameClone = '';
    if (
      tableConfiguration?.downloadPdf === true ||
      tableConfiguration?.downloadPdf === 'true'
    ) {
      if (
        tableConfiguration.downloadPdfPayload?.summaryType === true &&
        childTable?.[0]?.columns
      ) {
        pdfNameClone = await getPdfNametoDownload(
          columnsClone,
          currentDatasourceClone,
          tableConfiguration.downloadPdfPayload,
          childTable && childTable[0] ? childTable[0].columns : [],
          childDatasourceClone,
          weekSummaryDatasourceClone
        );
      } else {
        pdfNameClone = await getPdfNametoDownload(
          columnsClone,
          currentDatasourceClone,
          tableConfiguration.downloadPdfPayload
        );
      }

      setCurrentDatasource(currentDatasourceClone);
      setSummaryTable(summaryTableClone);
      setPdfName(pdfNameClone?.file || '');
      setApi(api);
      setSelectionObject(selectionObject);
    } else {
      setCurrentDatasource(currentDatasourceClone);
      setSummaryTable(summaryTableClone);
      setTagsList(TagsListClone);
      setApi(api);
      setSelectionObject(selectionObject);
    }
  }, [props.api, props.reportName, props.CurrentLanguage]);

  // Converted Fetch device hierarchy and update tree data state
  const getTreeData = useCallback(async () => {
    let hierarchyData = await _getDevicesList();
    setDeviceTreeData(hierarchyData);
  }, [_getDevicesList]); // if _getDevicesList is stable or memoized too

  const prevReportNameRef = useRef('');

  useEffect(() => {
    const currentReportName = props.reportName;

    // Only proceed if reportName has changed
    if (prevReportNameRef.current === currentReportName) return;

    // Update previous reportName
    prevReportNameRef.current = currentReportName;

    // Clear existing interval
    if (timeTicketRef.current) {
      clearInterval(timeTicketRef.current);
    }

    getTreeData();
    _getDataSource();

    const refreshTime = props.tableConfiguration?.pageRefreshFrequency ?? 1440;
    timeTicketRef.current = setInterval(() => {
      _getDataSource();
    }, refreshTime * 60000);

    return () => {
      if (timeTicketRef.current) {
        clearInterval(timeTicketRef.current);
      }
    };
  }, [reportName, props.CurrentLanguage]);
  useEffect(() => {
    _getDataSource();
  }, [
    props.CurrentLanguage
  ]);


  const _generateTreeData = (columns) => {
    let value = [];

    const treeData = Array.isArray(columns)
      ? columns.map((columnData) => {
        value.push(columnData.key);
        return {
          ...columnData,
          children: [],
          value: columnData.key
        };
      })
      : [];

    const summaryValue = value.filter(
      (key) =>
        key !== 'Date' &&
        key !== 'Total Consumption With Losses' &&
        key !== 'Total Cost per KWH'
    );

    return {
      treeData,
      value,
      summaryValue: ['Summary', ...summaryValue]
    };
  };


  const getStartDate = (widget, format, year, month) => {
    switch (widget) {
      case 'year-picker':
        return moment([year]).startOf('year').utc().format(format);
      case 'date-picker':
        return moment().subtract(1, 'day').startOf('day').utc().format(format);
      case 'dateRange-picker':
        return moment().subtract(30, 'days').format(format);
      case 'weak-picker':
        return moment().startOf('week').utc().format(format);
      case 'dayMonthYear-picker':
        return moment().startOf('day').utc().format(format);
      default:
        return moment([year, month]).startOf('month').utc().format(format);
    }
  };


  const getEndDate = (widget, format, year, month) => {
    switch (widget) {
      case 'year-picker':
        return moment([year]).endOf('year').utc().format(format);
      case 'date-picker':
        return moment().endOf('day').subtract(1, 'day').utc().format(format);
      case 'dateRange-picker':
        return moment().format(format);
      case 'weak-picker':
        return moment().endOf('week').utc().format(format);
      case 'dayMonthYear-picker':
        return moment().endOf('day').utc().format(format);
      default:
        return moment([year, month]).endOf('month').utc().format(format);
    }
  };




  const getPlusThreeNumbersUntilTotal = (start, total, span) => {
    let result = [];
    let current = start;

    while (current <= total) {
      result.push(current);
      current += span;
    }

    return result;
  };

  const generateColumnsFromDatasource = (currentDatasources) => {
    let { colSpanProp } = tableConfiguration.prepareDynamicColumns || {};
    let keysFromData = Object.keys(currentDatasources);

    // Filter out excluded keys
    let newData = keysFromData
      .filter((key) => {
        const excludeKeys =
          tableConfiguration?.prepareDynamicColumns?.excludeKeys || [];
        return !excludeKeys.includes(key);
      })
      .map((inputString) => {
        const keys = inputString.split('$$$');

        let columns = keys.map((val) => {
          const keyData = val.split(':Color');

          return {
            title: keyData.length === 2 ? keyData[0] : val,
            dataIndex: inputString,
            key: inputString,
            width:
              tableConfiguration?.prepareDynamicColumns?.fixedWidth || 100,

            // Handle row spanning logic
            ...(colSpanProp?.show === true && colSpanProp.field === inputString
              ? {
                onCell: (_, index) => {
                  const totalList = getPlusThreeNumbersUntilTotal(
                    0,
                    colSpanProp.totalRows || 100,
                    colSpanProp.span || 0
                  );

                  return {
                    rowSpan: totalList.includes(index)
                      ? colSpanProp.span || 0
                      : 0
                  };
                }
              }
              : {}),

            render(text) {
              const isColorKey = keyData.length === 2;
              const isUTCColumn =
                tableConfiguration?.prepareDynamicColumns?.isUTCColumns?.includes(
                  inputString
                );
              const utcFormat =
                tableConfiguration?.prepareDynamicColumns?.isUTCFormat ||
                'YYYY-MM-DD HH:mm:ss';
              const applyBgColor =
                tableConfiguration?.prepareDynamicColumns?.applyBackgroundColor;

              return {
                children: (
                  <div
                    style={{
                      color: isColorKey
                        ? text !== undefined
                          ? text
                          : 'rgb(33, 73, 114)'
                        : 'white',
                      fontWeight: 'bold',
                      backgroundColor:
                        applyBgColor && isColorKey ? text : 'none'
                    }}
                  >
                    {text !== 'null' && !isColorKey
                      ? isUTCColumn
                        ? text === 'Total' || text === 'Average'
                          ? text
                          : text
                            ? moment.utc(text).local().format(utcFormat)
                            : null
                        : text
                      : '______'}
                  </div>
                )
              };
            }
          };
        });

        // Build nested structure
        let nested = columns.reduceRight((acc, curr, index) => {
          let obj = { ...curr, children: [] };
          obj.children.push(
            index === 0
              ? acc
              : { ...acc, dataIndex: inputString, key: inputString }
          );
          return obj;
        });

        return nested;
      });

    // Remove duplicate children at each level
    let noDupes = PrepareChildren(newData);

    let cleanedUpData =
      noDupes?.map((topLevelItem) => {
        return {
          ...topLevelItem,
          children: PrepareChildren(topLevelItem.children)
        };
      }) || [];

    return cleanedUpData;
  };


  const PrepareChildren = (newData) => {
    if (!Array.isArray(newData)) return [];

    const noDupes = newData.reduce((acc, currentItem) => {
      const existingParent = acc.find(
        (parent) => parent.title === currentItem.title
      );

      if (existingParent) {
        // Ensure children array exists on the parent
        if (!existingParent.children) {
          existingParent.children = [];
        }

        // Add all children from current item to existing parent
        if (Array.isArray(currentItem.children)) {
          currentItem.children.forEach((child) => {
            // Optional: Prevent duplicate children by title
            // const childExists = existingParent.children.some(c => c.title === child.title);
            // if (!childExists) {
            //   existingParent.children.push(child);
            // }

            // Current version allows duplicates
            existingParent.children.push(child);
          });
        }
      } else {
        acc.push(currentItem);
      }

      return acc;
    }, []);

    return noDupes;
  };


  const columnValidation = (columnsData, columnValue) => {
    if (!Array.isArray(columnsData)) return [];

    return columnsData.filter((column) => {
      if (!column.noEquipment && !column.yesEquipment) {
        // Include columns without these flags
        return true;
      }
      if (columnValue === 'no') {
        return column.noEquipment === true;
      }
      if (columnValue === 'yes') {
        return column.yesEquipment === true;
      }
      // If columnValue is neither 'yes' nor 'no', exclude the column
      return false;
    });
  };


  const selectionPayloadHandler = async (selectionPayload) => {
    let weekSummaryTable = cloneDeep(props.weekSummaryTable);
    let { childTable, tableConfiguration } = props;
    let { headerSelection } = tableConfiguration;
    let clonedColumns = cloneDeep(columns);
    let TagsListData = clonedColumns.map((col) => col.key);

    // Filter out unwanted tags once
    const filteredTagsList = TagsListData.filter(
      (e) => !['Date', 'Total Consumption With Losses', 'Total Cost per KWH'].includes(e)
    );

    // Helper to update api.payload with selection + optionally TagsList
    const updatePayloadWithSelection = (apiPayload, selectionPayload, addTagsList) => ({
      ...apiPayload,
      ...selectionPayload,
      ...(addTagsList ? { TagsList: filteredTagsList } : {}),
    });

    // If there's a default value in headerSelection, add it to api payload
    if (headerSelection?.[0]) {
      const { defaultValue, key } = headerSelection[0];
      if (defaultValue && key) {
        api.payload = {
          ...api.payload,
          ...selectionPayload,
          [key]: defaultValue,
        };
      }
    }

    // Determine if we should include TagsList based on columnFilter config
    const includeTagsList = tableConfiguration?.columnFilter === 'true';

    // Update main api payload accordingly
    api.payload = updatePayloadWithSelection(api.payload, selectionPayload, includeTagsList);

    // Handle child table data fetching and payload update
    if (childTable?.[0]?.api) {
      childTable[0].api.payload = updatePayloadWithSelection(childTable[0].api.payload, selectionPayload, includeTagsList);

      const fetchedChildDatasource = await getDataSourceFromBackend(childTable[0].api);
      setChildDatasource(fetchedChildDatasource);
    }

    // Handle week summary table payload and data fetching
    if (weekSummaryTable?.api) {
      weekSummaryTable.api.payload = updatePayloadWithSelection(weekSummaryTable.api.payload, selectionPayload, includeTagsList);

      const fetchedWeekSummaryDatasource = await getDataSourceFromBackend(weekSummaryTable.api);
      setWeekSummaryDatasource(fetchedWeekSummaryDatasource);
    }

    // Fetch main datasource with updated api
    const fetchedCurrentDatasource = await getDataSourceFromBackend(api);

    // Prepare dynamic columns if enabled and datasource is valid
    if (
      tableConfiguration?.prepareDynamicColumns?.enable === true &&
      Array.isArray(fetchedCurrentDatasource) &&
      fetchedCurrentDatasource[0]
    ) {
      const newColumns = generateColumnsFromDatasource(fetchedCurrentDatasource[0]);
      if (tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        const reportName = await getReportNametoDownload(
          newColumns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadExcelPayload,
          childTable?.[0]?.columns || [],
          childDatasource,
          weekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment
              .utc(selectionObject.endDate)
              .local()
              .format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
        setReportName(reportName);
      }
      const treeDataNew = await _generateTreeData(newColumns);
      setColumns(newColumns);
      setValue(treeDataNew.value);
    }

    // Handle multi-variant columns and filter options
    if (Array.isArray(fetchedCurrentDatasource)) {
      clonedColumns = clonedColumns.map((columnObject) => {
        if (columnObject?.filter === true) {
          const filterOptions = fetchedCurrentDatasource
            .map((datasource) =>
              datasource[columnObject.key]
                ? { text: datasource[columnObject.key], value: datasource[columnObject.key] }
                : null
            )
            .filter(Boolean);

          return {
            ...columnObject,
            filters: _.uniqBy(filterOptions, 'text'),
          };
        }

        if (columnObject?.key === 'Action') {
          return {
            ...columnObject,
            render: () => <a href="/#" target="_blank" rel="noopener noreferrer">action</a>,
          };
        }

        return columnObject;
      });
    }

    // Helper for generating report names
    const generateReportName = async () => {
      if (
        tableConfiguration.downloadExcelPayload?.summaryType === 'true' &&
        childTable?.[0]?.columns &&
        tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true'
      ) {
        return await getReportNametoDownload(
          clonedColumns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadExcelPayload,
          childTable && childTable[0] ? childTable[0].columns : [],
          childDatasource,
          weekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionPayload.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment
              .utc(selectionPayload.endDate)
              .local()
              .format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
      } else if (props.nestedChildColumns && tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        return await getReportNametoDownloadMultiVaraint(
          clonedColumns,
          fetchedCurrentDatasource,
          props.nestedChildColumns,
          tableConfiguration.downloadExcelPayload
        );
      } else if (tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        return await getReportNametoDownload(
          clonedColumns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadExcelPayload,
          childTable?.[0]?.columns || [],
          childDatasource,
          weekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionPayload.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment
              .utc(selectionPayload.endDate)
              .local()
              .format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
      }
    };

    // Handle Excel download if enabled
    if (tableConfiguration.downloadXLXS === true || tableConfiguration.downloadXLXS === 'true') {
      const reportNameObj = await generateReportName();
      setCurrentDatasource(fetchedCurrentDatasource);
      setSelectionObject(selectionPayload);
      setReportName(reportNameObj?.file || '');
      setColumns(clonedColumns);
    } else {
      // If no Excel download, just update state
      setCurrentDatasource(fetchedCurrentDatasource);
      setWeekSummaryDatasource(weekSummaryDatasource);
      setSelectionObject(selectionPayload);
      setColumns(clonedColumns);
      setApi({ ...api }); // clone to trigger re-render if needed
    }

    // Handle PDF download if enabled
    if (tableConfiguration.downloadPdf === true || tableConfiguration.downloadPdf === 'true') {
      let pdfNameClone = '';
      if (
        tableConfiguration.downloadPdfPayload?.summaryType === 'true' &&
        childTable?.[0]?.columns
      ) {
        pdfNameClone = await getPdfNametoDownload(
          clonedColumns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadPdfPayload,
          childTable && childTable[0] ? childTable[0].columns : [],
          childDatasource,
          weekSummaryDatasource
        );
      } else {
        pdfNameClone = await getPdfNametoDownload(
          clonedColumns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadPdfPayload
        );
      }
      setCurrentDatasource(fetchedCurrentDatasource);
      setSelectionObject(selectionPayload);
      setPdfName(pdfNameClone?.file || '');
    } else {
      // In case PDF download disabled, make sure state is set properly
      setCurrentDatasource(fetchedCurrentDatasource);
      setWeekSummaryDatasource(weekSummaryDatasource);
      setSelectionObject(selectionPayload);
      setApi({ ...api }); // clone to trigger re-render if needed
    }
  };


  const onChange = async (newValue) => {
    await onTagChange(newValue);
    const updatedValue = ['Date', ...newValue, 'Total'];
    const newSummaryValue = ['Summary', ...updatedValue, 'Total'];
    setValue(updatedValue);
    setSummaryValue(newSummaryValue);
  };


  const onTagChange = async (TagsList) => {
    let apiClone = cloneDeep(props.api);
    let selectionClone = { ...selectionObject };
    let { childTable, tableConfiguration } = props;
    let weekSummaryTable = props.weekSummaryTable;

    const filteredTags = TagsList.filter(
      (e) => e !== 'Date' && e !== 'Total Consumption With Losses' && e !== 'Total Cost per KWH'
    );

    // Helper to update payload conditionally
    const updatePayload = (apiPayload) => {
      return tableConfiguration?.columnFilter === 'true'
        ? { ...apiPayload, ...selectionClone, TagsList: filteredTags }
        : { ...apiPayload, ...selectionClone };
    };

    // Update main API payload
    apiClone.payload = updatePayload(apiClone.payload);

    // Fetch child datasource if applicable
    let fetchedChildDatasource = [];
    if (childTable?.[0]?.api) {
      childTable[0].api.payload = updatePayload(childTable[0].api.payload);
      fetchedChildDatasource = await getDataSourceFromBackend(childTable[0].api);
      setChildDatasource(fetchedChildDatasource);
    }

    // Fetch week summary datasource if applicable
    let fetchedWeekSummaryDatasource = [];
    if (weekSummaryTable?.api) {
      weekSummaryTable.api.payload = updatePayload(weekSummaryTable.api.payload);
      fetchedWeekSummaryDatasource = await getDataSourceFromBackend(weekSummaryTable.api);
      setWeekSummaryDatasource(fetchedWeekSummaryDatasource);
    }

    let multiVariantColumns = cloneDeep(props.nestedChildColumns);
    let fetchedCurrentDatasource = await getDataSourceFromBackend(apiClone);

    // Dynamic columns generation and tree data update
    if (tableConfiguration?.prepareDynamicColumns?.enable && fetchedCurrentDatasource?.[0]) {
      const newColumns = generateColumnsFromDatasource(fetchedCurrentDatasource[0]);
      if (tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        const reportName = await getReportNametoDownload(
          newColumns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadExcelPayload,
          childTable?.[0]?.columns || [],
          fetchedChildDatasource,
          fetchedWeekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionClone.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionClone.endDate).local().format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
        setReportName(reportName);
      }
      const treeDataNew = await _generateTreeData(newColumns);
      setColumns(newColumns);
      setValue(treeDataNew.value);
    }

    // Excel report generation logic
    if (props.tableConfiguration?.downloadXLXS) {
      let reportName = '';
      if (props.tableConfiguration.downloadExcelPayload?.summaryType === 'true' && childTable?.[0]?.columns &&
        tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true'
      ) {
        reportName = await getReportNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadExcelPayload,
          childTable && childTable[0] ? childTable[0].columns : [],
          fetchedChildDatasource,
          fetchedWeekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionClone.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionClone.endDate).local().format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
      } else if (props.nestedChildColumns && tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        reportName = await getReportNametoDownloadMultiVaraint(
          columns,
          fetchedCurrentDatasource,
          multiVariantColumns,
          props.tableConfiguration.downloadExcelPayload
        );
      } else if (tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        reportName = await getReportNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadExcelPayload,
          childTable?.[0]?.columns || [],
          fetchedChildDatasource,
          fetchedWeekSummaryDatasource,
          {
            SelectedDate: `${moment.utc(selectionClone.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment.utc(selectionClone.endDate).local().format('YYYY-MM-DD HH:mm')}`,
          },
          tableConfiguration
        );
      }
      setCurrentDatasource(fetchedCurrentDatasource);
      setReportName(reportName?.file || '');
    } else {
      setCurrentDatasource(fetchedCurrentDatasource);
    }

    // PDF report generation logic
    if (props.tableConfiguration?.downloadPdf) {
      let pdfName = '';
      if (props.tableConfiguration.downloadPdfPayload?.summaryType === 'true' && childTable?.[0]?.columns) {
        pdfName = await getPdfNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadPdfPayload,
          childTable && childTable[0] ? childTable[0].columns : [],
          fetchedChildDatasource,
          fetchedWeekSummaryDatasource
        );
      } else {
        pdfName = await getPdfNametoDownload(
          columns,
          fetchedCurrentDatasource,
          props.tableConfiguration.downloadPdfPayload
        );
      }
      setCurrentDatasource(fetchedCurrentDatasource);
      setPdfName(pdfName?.file || '');
    } else {
      setCurrentDatasource(fetchedCurrentDatasource);
    }
  };


  const onSelectionChange = async (TagsList) => {
    let api = cloneDeep(props.api);
    let year = moment().year();
    let payload = {};

    const { selectionWidget, tableConfiguration, childTable, weekSummaryTable, nestedChildColumns } = props;

    const selectedDateStr = `${moment.utc(selectionObject.startDate).local().format('YYYY-MM-DD HH:mm')}~${moment
      .utc(selectionObject.endDate)
      .local()
      .format('YYYY-MM-DD HH:mm')}`;

    const supportedWidgets = [
      'year-picker',
      'date-picker',
      'dateRange-picker',
      'weak-picker',
      'dayMonthYear-picker',
    ];

    if (selectionWidget?.payload) {
      Object.keys(selectionWidget.payload).forEach((payloadParam, key) => {
        if (key <= 1 && supportedWidgets.includes(selectionWidget.widget)) {
          payload[payloadParam] = key === 0 ? selectionObject.startDate : selectionObject.endDate;
        }

        if (payloadParam === 'month') {
          payload[payloadParam] = moment().format('MMMM');
        }

        if (payloadParam === 'year') {
          payload[payloadParam] = year;
        }

        if (payloadParam === 'Date') {
          payload[payloadParam] = moment().subtract(1, 'day').format('YYYY-MM-DD');
        }
      });
    }

    api.payload = {
      ...api.payload,
      ...payload,
      ...TagsList,
    };

    let childDatasource = [];
    let weekSummaryDatasource = [];

    // Fetch child datasource
    if (childTable?.[0]?.api) {
      childTable[0].api.payload = {
        ...childTable[0].api.payload,
        ...payload,
        ...TagsList,
      };
      childDatasource = await getDataSourceFromBackend(childTable[0].api);
      setChildDatasource(childDatasource);
    }

    // Fetch week summary datasource
    if (weekSummaryTable?.api) {
      weekSummaryTable.api.payload = {
        ...weekSummaryTable.api.payload,
        ...payload,
        ...TagsList,
      };
      weekSummaryDatasource = await getDataSourceFromBackend(weekSummaryTable.api);
      setWeekSummaryDatasource(weekSummaryDatasource);
    }

    // Fetch current datasource
    const fetchedCurrentDatasource = await getDataSourceFromBackend(api);

    // Prepare dynamic columns if enabled
    if (tableConfiguration?.prepareDynamicColumns?.enable && fetchedCurrentDatasource?.[0]) {
      const newColumns = generateColumnsFromDatasource(fetchedCurrentDatasource[0]);
      if (tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        const reportName = await getReportNametoDownload(
          newColumns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadExcelPayload,
          childTable?.[0]?.columns || [],
          childDatasource,
          weekSummaryDatasource,
          { SelectedDate: selectedDateStr },
          tableConfiguration
        );
        setReportName(reportName);
      }

      const treeDataNew = await _generateTreeData(newColumns);

      setColumns(newColumns);
      setValue(treeDataNew.value);
    }

    // Update filters in columns (if any)
    if (Array.isArray(fetchedCurrentDatasource)) {
      const updatedColumns = columns.map((columnObject) => {
        if (columnObject?.filter) {
          const filters = fetchedCurrentDatasource
            .map((data) =>
              data[columnObject.key]
                ? { text: data[columnObject.key], value: data[columnObject.key] }
                : null
            )
            .filter(Boolean);

          return {
            ...columnObject,
            filters,
          };
        }
        return columnObject;
      });

      setColumns(updatedColumns);
    }

    // Handle Excel download
    if (tableConfiguration?.downloadXLXS) {
      let reportName = '';

      if (
        tableConfiguration.downloadExcelPayload?.summaryType === 'true' &&
        childTable?.[0]?.columns &&
        tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true'
      ) {
        reportName = await getReportNametoDownload(
          columns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadExcelPayload,
          childTable && childTable[0] ? childTable[0].columns : [],
          childDatasource,
          weekSummaryDatasource,
          { SelectedDate: selectedDateStr },
          tableConfiguration
        );
      } else if (nestedChildColumns && tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        const multiVariantColumns = cloneDeep(nestedChildColumns);

        reportName = await getReportNametoDownloadMultiVaraint(
          columns,
          fetchedCurrentDatasource,
          multiVariantColumns,
          tableConfiguration.downloadExcelPayload
        );
      } else if (tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
        reportName = await getReportNametoDownload(
          columns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadExcelPayload,
          childTable?.[0]?.columns || [],
          childDatasource,
          weekSummaryDatasource,
          { SelectedDate: selectedDateStr },
          tableConfiguration
        );
      }

      setReportName(reportName?.file || '');
    }

    // Handle PDF download
    if (tableConfiguration?.downloadPdf) {
      let pdfName = '';

      if (
        tableConfiguration.downloadPdfPayload?.summaryType === 'true' &&
        childTable?.[0]?.columns
      ) {
        pdfName = await getPdfNametoDownload(
          columns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadPdfPayload,
          childTable && childTable[0] ? childTable[0].columns : [],
          childDatasource,
          weekSummaryDatasource
        );
      } else {
        pdfName = await getPdfNametoDownload(
          columns,
          fetchedCurrentDatasource,
          tableConfiguration.downloadPdfPayload
        );
      }

      setPdfName(pdfName?.file || '');
    }

    setCurrentDatasource(fetchedCurrentDatasource);
  };


  const multiVariantonChange = async (pagination, filters) => {
    const multiVariantColumns = cloneDeep(props.nestedChildColumns);

    // Extract active filter keys and their values
    const activeFilterKeys = Object.keys(filters).filter(
      (key) => filters[key] !== null && filters[key]?.length
    );

    const filterValues = activeFilterKeys.flatMap((key) => filters[key]);
    const primaryKey = activeFilterKeys[0]; // Assuming filtering by one key only for now

    // Filter current datasource based on selected filter values
    const filteredData = currentDatasource.filter((row) =>
      filterValues.includes(row[primaryKey])
    );

    // Generate filtered report name
    if (tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
      const reportName = await getReportNametoDownloadMultiVaraint(
        columns,
        filteredData,
        multiVariantColumns,
        props.tableConfiguration.downloadExcelPayload
      );
      setReportName(reportName?.file || '');
    }
    // Update states
    setCurrentDatasource(filteredData);
    setFilteredInfo(filterValues);

    // Optionally re-fetch data source (if needed)
    _getDataSource();
  };



  const onInputChange = async (columnValue, columnkey, header, index, initialRender) => {
    setSelectedDevice(columnValue);

    let columnsClone = {};
    let newObject = {
      ...tableConfiguration.headerSelection[index],
      defaultValue: columnValue
    };

    delete tableConfiguration.headerSelection[index];
    tableConfiguration.headerSelection = tableConfiguration.headerSelection.filter(header => header);

    let { headerSelection } = tableConfiguration;
    if (headerSelection) {
      let tableConfigurationClone = {
        ...tableConfiguration,
        headerSelection: [...tableConfiguration.headerSelection, newObject]
      };

      let TagsListClone = {};
      tableConfigurationClone &&
        tableConfigurationClone.headerSelection &&
        Array.isArray(tableConfigurationClone.headerSelection) &&
        tableConfigurationClone.headerSelection.forEach((header) => {
          if (header) {
            TagsListClone = {
              ...TagsList,
              [header.key]: header.defaultValue
            };
          }
        });
      await onSelectionChange(TagsListClone);
      if (columnkey === 'isEquipment' && columnValue === 'no') {
        columnsClone = await this.columnValidation(columns, columnValue);
      } else if (columnkey === 'isEquipment' && columnValue === 'yes') {
        columnsClone = await this.columnValidation(columns, columnValue);
      } else {
        columnsClone = cloneDeep(columns);
      }
      setTableConfiguration(prev => ({
        ...prev,
        tableConfiguration,
        // columns,
        // initialRender
      }));
      setColumns(columnsClone);
      setInitalRender(initialRender);
    } else {
      message.warn('error');
    }
  };

  const {
    bordered,
    tableSize,
    noResultMessage,
    isCursorPointer,
    downloadXLXS,
    downloadPdf,
    headerSelection,
    pagination,
    horizontalScroll,
  } = tableConfiguration;

  const { columnFilter } = props.tableConfiguration || {};
  const { childTable, weekSummaryTable, nestedChildColumns } = props;


  const tProps = {
    treeData: Array.isArray(treeData)
      ? treeData.filter(
        (e) =>
          e.key !== 'Date' &&
          e.key !== 'Total' &&
          e.key !== 'Total Consumption With Losses' &&
          e.key !== 'Total Cost per KWH' &&
          e.key !== 'Total ATM Consumption(Day-Wise kWh)'
      )
      : [],
    value: Array.isArray(value)
      ? value.filter(
        (e) =>
          e !== 'Date' &&
          e !== 'Total' &&
          e !== 'Total Consumption With Losses' &&
          e !== 'Total Cost per KWH' &&
          e !== 'Total ATM Consumption(Day-Wise kWh)'
      )
      : [],
    onChange: (newValue) => onChange(newValue),
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: 'Select/Unselect', // ✅ fixed deprecated prop
    styles: {
      width: '70%',
      margin: '0px 10px',
      popup: {
        root: {
          maxHeight: 400,
          overflow: 'auto',
        },
      },
    },

  };


  const tableTranslation = (columnName, translationCache) => {
    if (columnName.length > 0 && columnName !== undefined && translationCache !== undefined) {
      columnName.map((column, key) => {
        if (translationCache[column.title] !== undefined) {
          if (translationCache[column.title]) {
            columnName[key].title = translationCache[column.title];
          }
        }
        return "";
      });
    }

    return columnName;
  };

  const onTreeSelectSubmit = async (columns, tagsList) => {
    let api = cloneDeep(props.api);

    api.payload = {
      ...api.payload,
      date: dayjs().format("YYYY-MM-DD"),
      days: dayjs().daysInMonth(),
      startDate: dayjs()
        .startOf('day')
        .utc()
        .format("YYYY-MM-DD HH:mm:ss"),
      endDate: dayjs()
        .endOf('day')
        .utc()
        .format("YYYY-MM-DD HH:mm:ss"),
      month: dayjs().format('MMMM'),
      year: dayjs().year(),
      selectionType: "DAY",  
      tags: tagsList
    };

    let currentDatasource = await getDataSourceFromBackend(api);

    let translationColumn = await tableTranslation(
      columns,
      props.translationCache
    );
    let excelDate = moment().format("YYYY-MM-DD");
    if (api.durationType && api.durationType === "daily") {
      excelDate = api.date;
    } else if (api.durationType && api.durationType === "monthly") {
      excelDate = moment(api.startDate, "YYYY-MM-DD").format('YYYY-MM');
    } else if (api.durationType && api.durationType === "yearly") {
      excelDate = moment(api.startDate, "YYYY-MM-DD").format('YYYY');
    }
    if (tableConfiguration?.downloadXLXS === true || tableConfiguration?.downloadXLXS === 'true') {
      let reportName = await getReportNametoDownload(
        translationColumn,
        currentDatasource,
        tableConfiguration.downloadExcelPayload,
        excelDate
      );
      setReportName(reportName && reportName.file ? reportName.file : "");
    }

    setColumns(translationColumn);
    setCurrentDatasource(currentDatasource);
    setTagsList(tagsList);
  };
  
  return (
    <div>
      {props?.deviceSelection?.displayWidget === true && (
        <TreeSelectComponent
          deviceTreeData={deviceTreeData}
          onTreeSelectSubmit={onTreeSelectSubmit}
        />
      )}

      {props.selectionWidget && (
        <SelectionComponent
          selectionWidget={props.selectionWidget}
          selectionpayload={selectionPayloadHandler}
          tags={TagsList}
        />
      )}

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          marginBottom: '10px',
          justifyContent: 'flex-end',
        }}
      >
        {headerSelection?.length > 0 && headerSelection[0] && (
          <SelectComponent
            id={0}
            column={headerSelection[0]}
            record={{ key: headerSelection[0].key }}
            {...initalRender}
            handleFieldChange={(e, initialRender, column) =>
              onInputChange(e, headerSelection[0].key, headerSelection[0], 0, initialRender, column)
            }
          />
        )}
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          cursor: 'pointer',
          marginBottom: '10px',
        }}
      >
        {downloadXLXS && reportName && (
          <a href={`${IPAddress.LOCAL}${REPORTS.Reports}/${reportName}`}>
            <DownloadOutlined />
          </a>
        )}

        {downloadPdf && pdfName && (
          <a href={`${IPAddress.LOCAL}${REPORTS.Reports}/${pdfName}`}>
            <FilePdfOutlined />
          </a>
        )}

        {tableConfiguration?.link?.map((links, index) => (
          <Tag key={links.path || index} color="#aaa3a3">
            <Link to={{ pathname: links.path }} style={{ marginRight: '10px' }}>
              {links.name}
            </Link>
          </Tag>
        ))}

        {(columnFilter === true || columnFilter === 'true') && <TreeSelect {...tProps} />}
      </div>

      {columns && Array.isArray(columns) && columns.length > 0 && !nestedChildColumns ? (
        <StyledTable
          columns={columns}
          dataSource={Array.isArray(currentDatasource) ? currentDatasource : []}
          bordered={bordered || false}
          size={tableSize || 'small'}
          locale={{ emptyText: noResultMessage }}
          isCursorPointer={isCursorPointer === true ? 'not-allowed' : 'pointer'}
          onChange={multiVariantonChange}
          loading={false}
          scroll={horizontalScroll ? { x: 120, y: 550 } : {}}
          pagination={pagination || false}
          title={() => {
            return <div style={{
              fontWeight: 'bold',
              textAlign: 'center',
            }}>{props.reportName}</div>;
          }}
        />
      ) : null}

      {columns &&
        columns.length >= 0 &&
        nestedChildColumns &&
        Array.isArray(nestedChildColumns) &&
        nestedChildColumns[0]?.columns && (
          <StyledTable
            columns={columns.filter((col) => value.includes(col.key))}
            dataSource={Array.isArray(currentDatasource) ? currentDatasource : []}
            bordered={bordered || false}
            size={tableSize || 'small'}
            locale={{ emptyText: noResultMessage }}
            isCursorPointer={isCursorPointer === true ? 'not-allowed' : 'pointer'}
            onChange={multiVariantonChange}
            loading={false}
            scroll={{ x: 120, y: 550 }}
            pagination={false}
            expandedRowRender={(record) => (
              <StyledTable
                size="small"
                columns={
                  nestedChildColumns?.[0]?.columns
                    ? nestedChildColumns[0].columns
                    : []
                }
                dataSource={
                  Array.isArray(record.multiVariantChildren)
                    ? record.multiVariantChildren
                    : []
                }
                style={{ padding: '25px' }}
                pagination={false}
              />
            )}
          />
        )}

      {!(
        columns &&
        columns.length >= 0 &&
        nestedChildColumns &&
        Array.isArray(nestedChildColumns) &&
        nestedChildColumns[0]?.columns
      ) && <div />}

      {childTable?.[0]?.columns?.length > 0 && (
        <ChildTablesGroup>
          <StyledTable
            columns={summaryTable || []}
            dataSource={Array.isArray(childDatasource) ? childDatasource : []}
            bordered={bordered || false}
            size={tableSize || 'small'}
            locale={{ emptyText: noResultMessage }}
            loading={false}
            style={{ marginTop: '30px' }}
            scroll={{ x: 120, y: 550 }}
            pagination={false}
          />
        </ChildTablesGroup>
      )}

      {childTable?.[0]?.columns?.length > 0 && weekSummaryTable && (
        <ChildTablesGroup>
          <StyledTable
            columns={
              summaryTable
                ? summaryTable.filter((col) => summaryValue.includes(col.key))
                : []
            }
            dataSource={weekSummaryDatasource}
            bordered={bordered || false}
            size={tableSize || 'small'}
            locale={{ emptyText: noResultMessage }}
            loading={false}
            style={{ marginTop: '30px' }}
            scroll={{ x: 120, y: 550 }}
            pagination={false}
          />
        </ChildTablesGroup>
      )}
    </div>


  );
};

const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(ReportTable);
